var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryptoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70996 15.9946H10.5225V13.877C10.2682 13.9043 9.99747 13.9233 9.70996 13.935V15.9946Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34956 5.70996H5.09326V6.77937H7.0719L7.34956 5.70996Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0719 12.873H5.09326V13.9425H7.42399L7.0719 12.873Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23662 3.50391H7.42407V15.9956H8.23662V3.50391Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.46 9.49713V9.47268C12.6101 9.15744 13.3066 8.46567 13.3066 7.67684C13.3066 7.03359 12.9665 6.54832 12.3995 6.23308C11.9198 5.94193 11.3254 5.76643 10.5227 5.68652V6.53592C11.3604 6.695 11.8814 7.08358 11.8814 7.7852C11.8814 8.37518 11.3922 8.84914 10.5227 9.05127V10.0528C11.5159 10.2385 12.2215 10.7059 12.2215 11.5349C12.2215 12.4105 11.4907 12.859 10.5227 13.0341V13.8776C11.5177 13.7711 12.2646 13.5442 12.7885 13.1851C13.3394 12.7849 13.712 12.25 13.712 11.5469C13.712 10.3341 12.497 9.69123 11.4604 9.49676H11.46V9.49713Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.422302,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82764 5.80823V13.8534C7.55407 13.9308 8.28416 13.9632 9.01461 13.9505C9.76914 13.9373 10.5222 13.876 11.2691 13.7669C10.8134 13.8786 10.4551 13.6644 10.4226 13.4663C10.3927 13.2839 10.6229 13.0069 11.0111 12.9154C10.6722 12.9938 10.3285 13.0511 9.98259 13.0865C9.72755 13.1124 9.52651 13.1233 9.41961 13.1251C9.02483 13.131 8.63005 13.1149 8.23709 13.0766V9.95816H9.40282C9.55242 9.95341 9.71478 9.95524 9.88845 9.96692C10.1453 9.98443 10.4004 10.0224 10.6514 10.08L10.5226 9.05221C10.3252 9.10219 10.1234 9.13503 9.9202 9.15036C9.78556 9.16057 9.65056 9.16313 9.51593 9.15765H8.23709V6.52445C8.996 6.42156 9.7655 6.42558 10.5233 6.53722C10.489 6.25117 10.4551 5.96549 10.4212 5.67944C10.0953 5.65645 9.75601 5.64222 9.40355 5.63857C8.54175 5.62981 7.68105 5.68673 6.828 5.80823H6.82764Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.422302,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5227 3.50391H9.71021V5.64163C10.0032 5.64746 10.2732 5.66279 10.5227 5.68723V3.50427V3.50391Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0393 33.1124C7.59909 32.9486 6.43628 31.5727 6.37061 29.5419H7.82822C7.91032 30.9338 8.74549 31.8018 10.5472 31.8018C12.2179 31.8018 13.184 31.1469 13.184 29.8363C13.184 28.7228 12.5451 28.2313 11.3006 27.9693L9.62991 27.6088C7.81181 27.2159 6.76356 26.2658 6.76356 24.5134C6.76356 22.7609 7.97563 21.5653 10.0389 21.385V20.042H11.1525V21.4015C13.1344 21.6145 14.461 22.9244 14.4771 24.7753H13.0195C12.9538 23.5308 12.135 22.7117 10.53 22.7117C9.17091 22.7117 8.23723 23.3013 8.23723 24.5134C8.23723 25.4467 8.81043 25.9381 10.0225 26.2165L11.5783 26.577C13.5438 27.0356 14.6737 27.9529 14.6737 29.8363C14.6737 31.7197 13.2979 32.9154 11.1525 33.0956V34.4551H10.0389V33.112H10.0393V33.1124Z",
    fill: "#F39200"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5393 10.21L21.0051 15.978L25.5393 18.3033L30.1898 15.978L25.5393 10.21Z",
    fill: "#F39200"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0051 17.4893L25.5973 19.6985L30.1898 17.4893L25.5973 24.3063L21.0051 17.4893Z",
    fill: "#F39200"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40244 18.5002C14.235 18.5002 18.1525 14.5826 18.1525 9.75009C18.1525 4.91755 14.235 1 9.40244 1C4.56989 1 0.652344 4.91755 0.652344 9.75009C0.652344 14.5826 4.56989 18.5002 9.40244 18.5002Z",
    stroke: "#29ABE2",
    strokeWidth: 0.879795,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5977 26.007C30.4303 26.007 34.3478 22.0895 34.3478 17.2569C34.3478 12.4244 30.4303 8.50684 25.5977 8.50684C20.7652 8.50684 16.8477 12.4244 16.8477 17.2569C16.8477 22.0895 20.7652 26.007 25.5977 26.007Z",
    stroke: "#29ABE2",
    strokeWidth: 0.879795,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8792 36.0002C15.7118 36.0002 19.6293 32.0826 19.6293 27.2501C19.6293 22.4175 15.7118 18.5 10.8792 18.5C6.0467 18.5 2.12915 22.4175 2.12915 27.2501C2.12915 32.0826 6.0467 36.0002 10.8792 36.0002Z",
    stroke: "#29ABE2",
    strokeWidth: 0.879795,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoIcon);
export default __webpack_public_path__ + "static/media/cryptoIcon.808a1d3b52ba8a3267edc3bfe53acad5.svg";
export { ForwardRef as ReactComponent };